package org.tlsys.api

import org.tlsys.AutoLoadAsyncListIterator
import org.tlsys.json.jdto

fun TransactionsService.getByMemberIterator(member: Long, minFull: Int, partSize: Int) = AutoLoadAsyncListIterator(minFull = minFull, max = partSize) { max, offset ->
    getByMember(member = member.jdto, max = max.jdto, offset = offset.jdto).promise
}